// Field-level rules for the cycle reminder form, mirroring ReminderCreate in
// services/master_data/app/schemas/cycle.py. A number input still accepts a typed "0",
// "-3" or "2.5" despite min/max, and the API answers those with a 422 whose body is a
// list of validation objects — checking here keeps the reason next to the field.
//
// Returns null when the input is usable, otherwise { field, message } where field is
// "when" or "threshold".
export const validateReminderInput = ({ when_value, threshold_value } = {}) => {
 const day = String(when_value ?? "").trim();
 if (day !== "") {
  if (!/^\d+$/.test(day)) {
   return { field: "when", message: "Enter whole days only, e.g. 10" };
  }
  if (parseInt(day, 10) < 1) {
   return { field: "when", message: "Must be at least 1 day after the cycle start" };
  }
 }

 const threshold = String(threshold_value ?? "").trim();
 if (threshold !== "") {
  if (!/^\d+$/.test(threshold)) {
   return { field: "threshold", message: "Enter a whole percentage, e.g. 40" };
  }
  const pct = parseInt(threshold, 10);
  if (pct < 1 || pct > 100) {
   return { field: "threshold", message: "Completion must be between 1% and 100%" };
  }
 }

 return null;
};

export default validateReminderInput;
